import { Dispatch } from 'redux'
import {
  add as addAction,
  set as setAction,
  setLoading,
  update as updateAction
} from 'states/dux/incident-report/actions'
import { Payload } from 'states/dux/incident-report/types'
import { Action } from 'states/types'
import { IncidentReport } from 'types/incident-report'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (reports: IncidentReport[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: reports
      })
    )
}

const add = (report: IncidentReport): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [report]
      })
    )
}

const update = (report: IncidentReport): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [report]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

export interface Operations {
  set: (reports: IncidentReport[]) => DispatchAction
  add: (report: IncidentReport) => DispatchAction
  update: (report: IncidentReport) => DispatchAction
  loading: (loading: boolean) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  update,
  loading
}

export { operations, set, add, update, loading }
